import React from "react";

const faqs = [
  {
    question: "Can I edit photos in my photo collage?",
    answer:
      'Absolutely! With our collage maker\'s powerful editing features, you can enhance your photos to perfection before assembling them into your collage. From adjusting brightness to cropping and applying filters, our intuitive editor ensures your images shine. Simply right-click on any photo and choose "Edit Photo" to access these tools.',
  },
  {
    question: "Do you support freestyle collages?",
    answer:
      "Yes, indeed! Our collage maker offers various freestyle collage layouts, providing flexibility beyond grid constraints. These dynamic photo collage layouts allow for unrestricted positioning, empowering you to craft visually captivating compositions. Explore pre-arranged styles like hearts, Christmas trees, or circles, adding an artistic flair to your collages.",
  },
  {
    question: "Can I zoom photos in my collage?",
    answer:
      "Yes, you can click on any image and drag the zoom slider to adjust the zoom. Then drag the image to position it perfectly.",
  },
  {
    question: "How can I make a free collage online?",
    answer:
      "Absolutely! PhotoJoiner’s free collage maker tool lets you create collages online for free. There are no registrations, software to install, or fees involved. It just works on any web browser!",
  },
  {
    question:
      "Are there any limits to the number of photos I can use in a collage?",
    answer:
      "While our collage layouts can support up to 20 photos, there's flexibility to incorporate even more images using additional cells or floating images. Our collage maker empowers you to expand your creativity beyond limits, ensuring that you can include all your cherished photos in a single collage.",
  },
  {
    question: "Can I customize the layout and design of my collage?",
    answer:
      "Absolutely! With our collage maker, you have full control over the layout and design of your photo collages. We offer extensive customization options, including the ability to rotate and resize objects, add text with various fonts and styles, apply borders for added flair, and even customize the dimensions of your collage to suit your preferences. Our user-friendly interface makes it easy to personalize every aspect of your collage, ensuring that each creation is unique and visually stunning.",
  },
  {
    question:
      "Do you offer templates for specific occasions like birthdays or weddings?",
    answer:
      "Yes, our photo collage maker provides an extensive range of templates tailored for various occasions, including birthdays, weddings, and more. These professionally crafted templates offer a seamless starting point for your collage creation, ensuring that your special moments are beautifully showcased with ease. Simply search for a template and click on it to load it to the canvas, then add your photos!",
  },
];

const FaqSection = () => {
  return (
    <div className="bg-[#EEEEEE] py-[96px] text-black flex flex-col items-center justify-center">
      <h2 className="font-bold text-3xl lg:text-4xl px-8">
        Frequently asked questions.
      </h2>
      <div className="flex flex-col gap-3 pt-[80px] px-8">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="py-[20px] bg-white rounded-lg p-8 max-w-4xl"
          >
            <div className="font-bold text-2xl">{faq.question}</div>
            <p className="text-sm pt-3">{faq.answer}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FaqSection;
